import * as Sentry from "@sentry/react";

declare global {
  interface Window {
    SENTRY_DSN_FRONTEND?: string;
    SENTRY_ENVIRONMENT?: string;
  }
}

function resolveVar(
  windowVal: string | undefined,
  viteVal: string,
): string | undefined {
  if (!windowVal || windowVal.startsWith("{{")) return viteVal || undefined;
  return windowVal;
}

export function initSentry() {
  const dsn = resolveVar(
    window.SENTRY_DSN_FRONTEND,
    import.meta.env.VITE_SENTRY_DSN_FRONTEND,
  );
  const environment = resolveVar(
    window.SENTRY_ENVIRONMENT,
    import.meta.env.VITE_SENTRY_ENVIRONMENT,
  );

  if (!dsn || !environment) return;

  Sentry.init({
    dsn,
    environment,
  });
}
